import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import "./SubPage.css";
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';

const SubPage = () => {
  const [formData, setFormData] = useState({
    lockboxType: [],
    lockboxOther: "",
    lockboxCombo: "",
    lockboxLocation: "",
    occupancy: [],
    contact1Name: "",
    contact1Phone: "",
    contact1Email: "",
    contact1Notify: [],
    contact2Name: "",
    contact2Phone: "",
    contact2Email: "",
    contact2Notify: [],
    additionalInfo: "",
  });

  const [properties, setProperties] = useState([
    { mls: "", street: "", city: "", state: "", zip: "" },
  ]);

  const handleCheckboxChange = (field, value) => {
    setFormData((prev) => {
      const current = prev[field];
      return {
        ...prev,
        [field]: current.includes(value)
          ? current.filter((v) => v !== value)
          : [...current, value],
      };
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleChangeAddress = (index, field, value) => {
    const newProperties = [...properties];
    newProperties[index][field] = value;
    setProperties(newProperties);
  };

  const addProperty = () => {
    setProperties([
      ...properties,
      { mls: "", street: "", city: "", state: "", zip: "" },
    ]);
  };

  const removeProperty = (index) => {
    if (index === 0) return; // never remove first property
    const newProperties = properties.filter((_, i) => i !== index);
    setProperties(newProperties);
  };

  const [fullName, setFullName] = useState("");

  useEffect(() => {
    async function loadUser() {
      try {
        const user = await getCurrentUser();
        // fetchAuthSession gives you tokens, which include user attributes
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken;
        const name = idToken?.payload?.name;

        setFullName(name || user.username || "User");
      } catch (err) {
        console.error("Error fetching user info:", err);
      }
    }
    loadUser();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Build properties string dynamically
    const propertiesMessage = properties
      .map(
        (p, index) =>
          `Property ${index + 1}:
          MLS #: ${p.mls}
          Street: ${p.street}
          City: ${p.city}
          State: ${p.state}
          Zip: ${p.zip}`
      )
      .join("\n\n");

    const emailParams = {
      agentName: fullName,
      properties: propertiesMessage,
      bestTimes: formData.additionalInfo,
      contact1Name: formData.contact1Name,
      contact1Phone: formData.contact1Phone,
      contact1Email: formData.contact1Email,
      contact1Notify: formData.contact1Notify.join(", "),
      contact2Name: formData.contact2Name,
      contact2Phone: formData.contact2Phone,
      contact2Email: formData.contact2Email,
      contact2Notify: formData.contact2Notify.join(", "),
    };

    emailjs
      .send(
        "service_58m64j5",   // replace with your EmailJS service ID
        "template_1plu6qm",  // replace with your EmailJS template ID
        emailParams,
        "hAJmqdyYf07E3qAtY"    // replace with your EmailJS public key
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          alert("Form submitted successfully!");

          // Reset form
          setFormData({
            lockboxType: [],
            lockboxOther: "",
            lockboxCombo: "",
            lockboxLocation: "",
            occupancy: [],
            contact1Name: "",
            contact1Phone: "",
            contact1Email: "",
            contact1Notify: [],
            contact2Name: "",
            contact2Phone: "",
            contact2Email: "",
            contact2Notify: [],
            additionalInfo: "",
          });
          setProperties([{ mls: "", street: "", city: "", state: "", zip: "" }]);
        },
        (err) => {
          console.error("FAILED...", err);
          alert("Failed to send form. Please try again.");
        }
      );
  };

  return (
    <div className="subpage-container">
      <h1>Showing Request Form</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <h2>Listing Information</h2>
          {properties.map((property, index) => (
            <div key={index} className="property-block">
              <h3>Property {index + 1}</h3>
              <div className="agent-group">
                <input
                  className="adress-MLS"
                  type="text"
                  placeholder="MLS #"
                  value={property.mls}
                  onChange={(e) => handleChangeAddress(index, "mls", e.target.value)}
                />
                <input
                  className="address-text"
                  type="text"
                  placeholder="Street Address"
                  value={property.street}
                  onChange={(e) => handleChangeAddress(index, "street", e.target.value)}
                />
              </div>
              <div className="agent-group">
                <input
                  type="text"
                  placeholder="City"
                  value={property.city}
                  onChange={(e) => handleChangeAddress(index, "city", e.target.value)}
                />
                <input
                  type="text"
                  placeholder="State"
                  value={property.state}
                  onChange={(e) => handleChangeAddress(index, "state", e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Zip"
                  value={property.zip}
                  onChange={(e) => handleChangeAddress(index, "zip", e.target.value)}
                />
              </div>
              {index > 0 && (
                <button
                  className="remove-property-button"
                  type="button"
                  onClick={() => removeProperty(index)}
                >
                  Remove This Property
                </button>
              )}
            </div>
          ))}

          <button className="add-property-button" type="button" onClick={addProperty}>
            Add Another Property
          </button>
        </div>

        <h3>Best Dates/Times for a Showing (Time of Day, Day of the Week, etc.)</h3>
        <textarea
          name="additionalInfo"
          className="misc-text"
          value={formData.additionalInfo}
          onChange={handleChange}
          rows={4}
        />

        <h2>Buyer Contact Information</h2>
        <h3>Contact 1</h3>
        <div className="contact-boxes">
          <div className="agent-group">
            <label>Name:</label>
            <input
              className="contact-textboxes"
              type="text"
              name="contact1Name"
              placeholder="First & Last Name"
              value={formData.contact1Name}
              onChange={handleChange}
            />
            <label>Phone Number:</label>
            <input
              className="contact-textboxes"
              type="text"
              placeholder="#"
              name="contact1Phone"
              value={formData.contact1Phone}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="agent-group">
          <label>Email:</label>
          <input
            className="contact-textboxes"
            type="email"
            name="contact1Email"
            placeholder="Email Address"
            value={formData.contact1Email}
            onChange={handleChange}
          />
          <label>Confirm Showing / Notify Via?</label>
          <div className="checkbox-group">
            {["Text", "Email", "Call"].map((option) => (
              <label key={option}>
                <input
                  type="checkbox"
                  checked={formData.contact1Notify.includes(option)}
                  onChange={() => handleCheckboxChange("contact1Notify", option)}
                />
                {option}
              </label>
            ))}
          </div>
        </div>

        <h3>Contact 2</h3>
        <div className="contact-boxes">
          <div className="agent-group">
            <label>Name:</label>
            <input
              type="text"
              className="contact-textboxes"
              name="contact2Name"
              placeholder="First and Last Name"
              value={formData.contact2Name}
              onChange={handleChange}
            />
            <label>Phone Number:</label>
            <input
              type="text"
              className="contact-textboxes"
              name="contact2Phone"
              placeholder="#"
              value={formData.contact2Phone}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="agent-group">
            <label>Email:</label>
            <input
              type="email"
              name="contact2Email"
              className="contact-textboxes"
              placeholder="Email Address"
              value={formData.contact2Email}
              onChange={handleChange}
            />
            <label>Confirm Showing / Notify Via?</label>
            <div className="checkbox-group">
            {["Text", "Email", "Call"].map((option) => (
              <label key={option}>
                <input
                  type="checkbox"
                  checked={formData.contact2Notify.includes(option)}
                  onChange={() => handleCheckboxChange("contact2Notify", option)}
                />
                {option}
              </label>
            ))}
          </div>
        </div>

        <div>
          <button type="submit">Submit</button>
        </div>
      </form>
    </div>
  );
};

export default SubPage;
